@use '@dixa/lib-shared-tokens/scss' as *;
@use 'common' as *;

.featureCard {
  flex: 1 0 165px;
  min-width: 165px;
  max-width: 23%;
  padding: var(--dixa-size-spacer-400) var(--dixa-size-spacer-300)
    var(--dixa-size-spacer-300);
  border-radius: var(--dixa-size-border-radius-100);
  border: var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);

  @media (max-width: $breakpoint-lg) {
    max-width: 50%;
  }
}
